export default __webpack_public_path__ + "static-bigflip/media/ilus-re-kyb-en.e0aecd43.webp";